import classNames from 'clsx';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { CasinoGameIcon, CasinoGameIconSL, CasinoGameList, CasinoSliderButtons } from '@swf/casino';
import type { SliderHandles, State as SliderState } from '@swf/components/Slider/Slider';
import { select } from '@swf/core/store';
import type { CasinoGame } from '@swf/core/types/CasinoGame';
import { Category } from '@swf/core/types/StarsCoinReward';

import { useCasinoMyRewardsWidgetModel } from '../../model';
import Container from '../Container/Container';
import type WithClose from '../WithClose';

import styles from './FreeSpins.scss';
import stylesSL from './FreeSpinsSL.scss';

interface Props extends WithClose {
  games: CasinoGame[];
}

const FreeSpins: React.FC<Props> = ({ games, close }) => {
  const { widgetConfig } = useCasinoMyRewardsWidgetModel();
  const isSL = widgetConfig.new_game_tile_view;
  const sliderRef = React.createRef<SliderHandles>();
  const [sliderState, setSliderState] = useState<SliderState>({ left: false, right: false });
  const isMobile = useSelector(select.device.isMobile);
  return (
    <Container
      category={Category.FSB}
      className={classNames(styles.container, {
        [styles.mobile]: isMobile
      })}
      right={!isMobile && <CasinoSliderButtons sliderRef={sliderRef} sliderState={sliderState} />}
      close={isMobile ? close : <div />}
    >
      <CasinoGameList
        className={classNames(isSL ? stylesSL.gameList : styles.gameList, {
          [styles.mobile]: isMobile
        })}
        fsbLaunch
        placeholder={
          isSL ? (
            <CasinoGameIconSL tileType="poster" images={{}} FSBPlaceholder />
          ) : (
            <CasinoGameIcon images={{}} FSBPlaceholder />
          )
        }
        games={games}
        icon="icnSquare"
        onScroll={setSliderState}
        preload
        tilesPerRow={5}
        sliderRef={sliderRef}
      />
    </Container>
  );
};

export default FreeSpins;
